import React from 'react';
import { Box, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { ToiletCounterWrapperBox, ToiletCountItemBox } from './ToiletOptions.styles';
import { useTranslation } from 'react-i18next';

import { palette } from '../../theme';
interface ToiletOptionsProps {
  showCaption?: boolean;
}
const ToiletOptions: React.FC<ToiletOptionsProps> = ({ showCaption = true }) => {
  const { t } = useTranslation();
  return (
    <Box
      px={2}
      py={showCaption ? 2 : 1}
      borderTop={showCaption ? `1px solid ${palette.line}` : undefined}
      sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      {showCaption && (
        <Typography variant="caption" fontWeight={600}>
          {t('events.optionsCaption')}
        </Typography>
      )}
      <Typography
        variant={showCaption ? 'h5' : 'body2'}
        fontWeight={400}
        color="text.primary"
        sx={{ fontSize: showCaption ? undefined : 14 }}
      >
        {t('events.toiletCounterHint')}
      </Typography>

      <ToiletCounterWrapperBox>
        <ToiletCountItemBox>
          <Remove sx={{ color: 'white' }} />
        </ToiletCountItemBox>
        <Box
          sx={{
            flex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <Typography variant="body1">3</Typography>
        </Box>
        <ToiletCountItemBox>
          <Add sx={{ color: 'white' }} />
        </ToiletCountItemBox>
      </ToiletCounterWrapperBox>
    </Box>
  );
};
export default ToiletOptions;
